import {
  Typography,
  useTheme,
  Box,
  styled,
  useMediaQuery,
  Grid,
  Container,
} from '@mui/material'
import ExpandableText from './ExpandableText'
import {
  IMAGE_BASE_PATH_DBRAIMT,
  IMAGE_BASE_PATH_COMMON,
  DBRAIMT_ASSET_FOLDER,
} from '../../Config/Config'

const TitleBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  position: 'relative',
  marginBottom: theme.spacing(2),
}))

const FloatImage = styled('img')(({ theme }) => ({
  width: '350px',
  maxWidth: '100%',
  height: 'auto',
  float: 'left',
  marginRight: theme.spacing(3),
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    float: 'none',
    marginRight: 0,
    width: '100%',
    marginBottom: theme.spacing(3),
  },
}))

const ContentWrapper = styled(Box)(({ theme }) => ({
  overflow: 'hidden', // Ensures text wraps properly
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

const InfoTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '&.designation': {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
}))

const HS = ({ HS_DATA }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const imageSrc =
    HS_DATA?.image === ''
      ? IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'
      : HS_DATA?.image

  return (
    <Container maxWidth="xl" id="HsStyle">
      <TitleBox>
        <Typography
          variant="h4"
          component="h5"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 'bold',
            position: 'relative',
            display: 'inline-block',
          }}
        >
          {HS_DATA.tittle}
          <Box
            sx={{
              position: 'absolute',
              width: '70px',
              height: '4px',
              backgroundColor: 'background.secondaryBackground',
              borderRadius: 1,
            }}
          />
        </Typography>
      </TitleBox>

      <Grid container>
        <Grid item xs={12}>
          <ContentWrapper>
            <div>
              <FloatImage
                src={
                  IMAGE_BASE_PATH_DBRAIMT +
                  DBRAIMT_ASSET_FOLDER +
                  '/' +
                  imageSrc
                }
                alt="Principal"
                onError={(e) =>
                  (e.target.src =
                    IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg')
                }
              />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  mt: isMobile ? 2 : 0,
                  color: theme.palette.text.primary,
                }}
              >
                {HS_DATA.name}
              </Typography>
              <InfoTypography variant="subtitle2" className="designation">
                {HS_DATA.designation}
              </InfoTypography>
            </div>
            <Box>
              <ExpandableText
                text={HS_DATA.description}
                style={{ color: theme.palette.text.primary }}
                buttonStyle={{ color: theme.palette.primary.main }}
                initialChars={800}
                showFullText={false}
              />
            </Box>
          </ContentWrapper>
        </Grid>
      </Grid>
    </Container>
  )
}

export default HS
